import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getTenantsFromReducer = get('tenants');

export const getIsLoading = state => fromReducer.getIsLoading(getTenantsFromReducer(state));

export const getTenants = state => fromReducer.getTenants(getTenantsFromReducer(state));
